
import React from "react";
import Icons from "../../../../Config/Images";
import Fonts from "../../../../Config/Fonts";
import Colors from "../../../../theme/Colors";

const RolePermissionTable = ({ onAddUsers, role, onAddRolePermissions }) => {
  return (
    <div style={mainContainer}>
      <div style={outerWrapper}>
        <div style={tableWrapper}>
          <div style={{ minWidth: "110%" }}>
            <table style={table}>
              <thead>
                <th style={tableLableStyle}>Sr No.</th>
                <th style={tableLableStyle}>Role</th>
                <th style={tableLableStyle}>Action</th>
              </thead>

              <tbody>
                {role?.map((roleDetails, index) => (
                  <tr>
                  <td style={tableInputStyle}>
                      {index + 1}
                    </td>
                    <td style={tableInputStyle}>
                      {roleDetails?.user_role_name}
                    </td>
                    <td style={tableInputStyle}>
                      <img
                        src={Icons.editIcon}
                        style={{
                          height: "20px",
                          width: "20px",
                          cursor: "pointer",
                          marginLeft: "20px",
                        }}
                        onClick={() => onAddRolePermissions(roleDetails)}
                        alt="Edit Icon"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const mainContainer = {
  marginTop: "30px",
  marginLeft: "24px",
  width: "50%",
  height: "32%",
};

const outerWrapper = {
  backgroundColor: Colors.white,
  display: "flex",
  flexDirection: "column",
};

const tableWrapper = {
  flexGrow: 1,
  borderRadius: 12,
};

const table = {
  minWidth: "90%",
  borderCollapse: "separate",
  borderSpacing: "0px",
  borderRadius: 12,
};

const tableLableStyle = {
  fontSize: 12,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.white,
  position: "sticky",
  top: 0,
  textAlign: "center",
  padding: "12px 5px",
  border: "1px solid #E6E6E6",
  backgroundColor: Colors.adminPrimaryColor,
};

const tableInputStyle = {
  fontSize: 12,
  fontWeight: 500,
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  textAlign: "center",
  padding: "8px 10px",
  border: "1px solid #E6E6E6",
}

export default RolePermissionTable;
